module.exports = __webpack_public_path__ + "static/media/crystal-full.2d03a7fa.png";